// The CSRF token Rails puts in the page head, for fetch calls that change state.
export function csrfToken() {
  return document.querySelector("meta[name='csrf-token']")?.getAttribute("content") || ""
}
